import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { ItemHealth } from "src/app/item-health";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-health-status-indicator",
	templateUrl: "./health-status-indicator.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["./health-status-indicator.component.scss"]
})
export class HealthStatusIndicatorComponent implements OnInit {
	@Input()
	item: APIResults.Fleet | APIResults.FleetAsset;
	@Input()
	component: "md" | "rtb" | "fdm" | "overall" = "overall";

	public itemHealth: ItemHealth;

	ngOnInit() {
		if ((this.item as APIResults.FleetAsset).asset_id !== undefined) {
			this.itemHealth = ItemHealth.FromAsset(this.item as APIResults.FleetAsset);
		} else {
			this.itemHealth = ItemHealth.FromFleet(this.item as APIResults.Fleet);
		}
	}
}
